// extracted by mini-css-extract-plugin
export default {"root":"CustomDatesPicker_root__m17k4","dates":"CustomDatesPicker_dates__PD4ze","date":"CustomDatesPicker_date__M-FlG","disabled":"CustomDatesPicker_disabled__auR-b"};